import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  templates: [],
  attributes: [],
  pending: true,
});

export const actions = {
  [ActionTypes.getTemplates]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        templates: payload,
        pending: false,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getAttributes]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        attributes: payload,
        pending: false,
      };
      return fromJS(newState);
    },
  },
};

export const template = handleActions(actions, initialState);
